// vendor libs
import * as Cookie from 'app/packages/cookie-utils';
import CONST from 'app/common/lib/Const';
import P from 'app/common/lib/P';
import urlUtil from 'app/common/lib/urlUtil';

// eslint-disable-next-line pinterest/no-referencing-p-properties
P.CookieTemp = Cookie;

/**
 * Library for functions that deal with the CSRF cookie.
 */
const Csrf = {};

/**
 * This code deals with a bug that existed on 8/13/13.
 *
 * Cookie cleanup.  Delete the domain-less 'csrftoken' cookie.
 * This is necessary so that we don't send back two csrf cookies
 * (one domain-less, one with '.example.com').
 *
 * Careful: Only attempt to delete the domainless cookie if there
 * are multiple 'csrftoken' values.  In IE, deleting the cookie without specifying
 * a domain will actually delete the wildcard cookie (".example.com").
 * IE's handling of this is different from other browsers.
 */
Csrf.cleanUpCookie = function() {
  const key = PCONST.COOKIE_CSRF;
  const tmp = document.cookie.match(new RegExp(key + '=.+?($|;)', 'g'));
  const hasMultipleCsrfTokens = tmp && tmp.length > 1;
  if (hasMultipleCsrfTokens) {
    Csrf.expireCookie(CONST.GEN.templateConst.settings.TRUSTED_HOSTNAME_ENDING);
  }
};

Csrf.clearSecondCookie = function() {
  /*
   * BUG-84979: the user has multiple CSRF tokens, and we want to delete as many as we can.
   * So, also delete the cookie on the users current domain (i.e. .www.pinterest.com)
   */
  if (!__SERVER__) {
    Csrf.expireCookie(window.location.hostname);
  }
};

Csrf.expireCookie = function(domain) {
  document.cookie =
    PCONST.COOKIE_CSRF +
    '=bad; domain=.' +
    domain +
    '; expires=Thu, 01-Jan-1970 00:00:00 GMT; Max-Age=0; Path=/';
};

/** @return {string} The CSRF token. */
Csrf.getCSRFToken = function() {
  // TODO(chris): Memoize this?  This doesn't change once the page has loaded.
  // eslint-disable-next-line pinterest/no-referencing-p-properties
  return typeof window !== 'undefined' ? P.CookieTemp.get(PCONST.COOKIE_CSRF) : '';
};

/**
 * @param {string} method The method of the XHR.
 * @return {boolean} True if the function doesn't need CSRF protection.
 * @private
 */
Csrf._isSafeMethod = function(method) {
  return /^(GET|HEAD|OPTIONS|TRACE)$/.test(method);
};

/**
 * Returns whether the request needs the CSRF token.
 * @param {string} method The method of the XHR.
 * @param {string} url The url of the XHR.
 * @return {boolean} True if the CSRF token should be added.
 * @private
 */
Csrf._needsCsrfToken = function(method, url) {
  return !Csrf._isSafeMethod(method) && urlUtil.isTrustedOrigin(url);
};

export default Csrf;
